export default {
  feedback: {
    login_success: 'Succesvol ingelogd',
    logout_success: 'Succesvol uitgelogd',
  },
};
